import * as React from 'react';
import {useContext, useEffect} from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import AppAppBar from '../components/AppAppBar';
import {ComingSoon} from '../components/ComingSoon';
import Pricing from '../components/Pricing';

import Footer from '../components/Footer';
import {AuthContext} from "../components/AuthContext";
import AppTheme from "../themes/AppTheme";
import {Box} from "@mui/material";
import {
  GithubLoggedInRequest,
  GithubLoggedInResponse,
  GoogleAccountInfoResponse,
  GoogleLoggedInRequest,
  LoginType
} from "../utils/types";
import {githubGetAccountDetails, googleGetAccountDetails} from "../apis/junkyard";
import {TradingSubPage} from "./TradingSubPage";

export function HomePage() {
  const authContext = useContext(AuthContext);


  useEffect(() => {
    async function getAccountDetails() {

      // Extract query parameters from URL
      const accessToken = authContext.readAccessToken();
      const loginType = authContext.getLoginType();
      console.debug("Auth context access token", accessToken);
      console.debug("Auth context login type", loginType);

      if (accessToken !== null) {
        try {
          if (authContext.getLoginType() === LoginType.github) {
            const resp = await githubGetAccountDetails({
              "access_token": accessToken,
              "page": 1,
              "per_page": 5
            } as GithubLoggedInRequest)
            const response = resp as GithubLoggedInResponse;
            // set the logged in name in the app bar
            console.debug("Got login name", response.name)
            authContext.setCurrentUser(response.name);
            if (!authContext.readAccessToken()) {
              authContext.storeAccessToken(accessToken)
            }
          } else if (authContext.getLoginType() === LoginType.google) {
            const resp = await googleGetAccountDetails({
              "access_token": accessToken,
              "page": 1,
              "per_page": 5
            } as GoogleLoggedInRequest)
            const response = resp as GoogleAccountInfoResponse;
            // set the logged in name in the app bar
            console.debug("Got login name from google", response.full_name)
            authContext.setCurrentUser(response.full_name);
            if (!authContext.readAccessToken()) {
              authContext.storeAccessToken(accessToken)
            }
          }
        } catch (error) {
          console.error(error);
        }

      }
    }
    getAccountDetails();
  }, [authContext]);

  return (
    <React.Fragment>
      <AppTheme>
        <CssBaseline enableColorScheme />
        <Box sx={{width: '100%', height: '100%'}}>
          <AppAppBar></AppAppBar>
          {authContext.isAuthenticated() ? (
              <TradingSubPage/>
          ) : (
              <>
                <ComingSoon/>
                <Pricing showButtons={true}/>
              </>
          )}
        </Box>
        <Footer />
      </AppTheme>
    </React.Fragment>
  );
}